import jsPDF from 'jspdf';
import { marked } from 'marked';

/**
 * Converts markdown to styled PDF and triggers download.
 * @param {string} markdown - The markdown content to convert.
 * @param {string} filename - The filename for the downloaded PDF.
 */
export async function downloadMarkdownAsPDF(markdown, filename = 'campaign_brief_chat.pdf') {
  const pdf = new jsPDF('p', 'mm', 'a4');
  const pageWidth = pdf.internal.pageSize.getWidth();
  const margin = 10;
  const textWidth = pageWidth - margin * 2;

  // Convert markdown to HTML
  let htmlContent = marked.parse(markdown);

  // Add inline styles for key markdown elements for better jsPDF compatibility
  htmlContent = htmlContent
    .replace(/<h1>(.*?)<\/h1>/gs, function(match, p1) {
      // Wrap h1 content in span with white-space:pre-wrap and max-width for wrapping
      return `<h1 style="color:#2a4d8f;font-size:2em;border-bottom:2px solid #eee;margin-top:1em;margin-bottom:0.5em;"><span style='white-space:pre-wrap;max-width:90vw;display:inline-block;'>${p1}</span></h1>`;
    })
    .replace(/<h2>/g, '<h2 style="color:#2a4d8f;font-size:1.5em;border-bottom:1px solid #eee;margin-top:1em;margin-bottom:0.5em;">')
    .replace(/<h3>/g, '<h3 style="color:#2a4d8f;font-size:1.2em;margin-top:1em;margin-bottom:0.5em;">')
    .replace(/<strong>/g, '<strong style="font-weight:bold;color:#1a237e;">')
    .replace(/<em>/g, '<em style="font-style:italic;color:#3949ab;">')
    .replace(/<ul>/g, '<ul style="margin-left:1.5em;margin-bottom:1em;">')
    .replace(/<ol>/g, '<ol style="margin-left:1.5em;margin-bottom:1em;">')
    .replace(/<li>/g, '<li style="margin-bottom:0.3em;">')
    .replace(/<blockquote>/g, '<blockquote style="border-left:4px solid #90caf9;background:#f5f5f5;padding:0.5em 1em;color:#333;margin:1em 0;">')
    .replace(/<code>/g, '<code style="background:#e3e3e3;color:#d32f2f;font-family:monospace;padding:2px 4px;border-radius:3px;">')
    .replace(/<pre>/g, '<pre style="background:#f5f5f5;padding:1em;border-radius:5px;overflow-x:auto;">');

  await pdf.html(htmlContent, {
    x: margin,
    y: 20,
    width: textWidth,
    windowWidth: 800,
  });
  pdf.save(filename);
}
